import React from "react";
import CustomBadge from "./CustomBadge";
import { withStyles } from "@material-ui/core/styles";
import appConstants from "../../../../../../appConstants";
const styles = (theme) => ({
  divStyle: {
    display: "flex",
    justifyContent: "center",
  },
});
const ShipmentBadgeList = ({
  classes,
  bills,
  pieces,
  hu,
  weight,
  stopType,
  stc,
  piecesLabel = "Pieces",
  huLabel = "HU",
  weightLabel = "LBS",
  /** Pickup: ordered badges from `buildPickupHeaderBadgeItems` (Bills first, then config field order). */
  headerBadgeItems,
}) => (
  <div className={classes.divStyle}>
    {Array.isArray(headerBadgeItems) && headerBadgeItems.length > 0 ? (
      headerBadgeItems.map((item) => (
        <CustomBadge
          key={item.key}
          value={item.value ?? "-"}
          labelText={item.label}
        />
      ))
    ) : (
      <>
        {stopType === appConstants.STOP_TYPE.Pickup && (
          <CustomBadge value={bills ? bills : "-"} labelText="Bills" />
        )}
        <CustomBadge value={pieces ? pieces : "-"} labelText={piecesLabel} />
        {stopType === appConstants.STOP_TYPE.Delivery && (
          <CustomBadge value={stc ? stc : "-"} labelText="STC" />
        )}
        <CustomBadge value={hu ? hu : "-"} labelText={huLabel} />
        <CustomBadge value={weight ? weight : "-"} labelText={weightLabel} />
      </>
    )}
  </div>
);
export default withStyles(styles)(ShipmentBadgeList);
